import service from '@/store/services/settings/stations-service';

const state = {
    list: {},
    station: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, station) => {
        state.station = station;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },
    ports ({ commit, dispatch }, station) {
        return service.ports(station)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },
    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(station => {
                commit('SET_RESOURCE', station);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(station => {
                commit('SET_RESOURCE', station);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((station) => {
                commit('SET_RESOURCE', station);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((station) => {
                commit('SET_RESOURCE', station);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    ports: state => state.ports,
    station: state => state.station,
    dropdown: (state) => {
        return state.list.map(station => ({
            id: station.id,
            uuid: station.uuid,
            name: station.name,
            short_name: station.short_name,
            code: station.code
        }));
    }
};

const stations = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default stations;
